function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var LiechtensteinFlag = props => /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
  width: "1em",
  height: "1em",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), {}, {
  children: [/*#__PURE__*/_jsx("mask", {
    id: "a",
    width: "24",
    height: "18",
    x: "0",
    y: "3",
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: 'luminance'
    },
    children: /*#__PURE__*/_jsx("path", {
      fill: "#fff",
      d: "M0 3h24v18H0z"
    })
  }), /*#__PURE__*/_jsxs("g", {
    mask: "url(#a)",
    children: [/*#__PURE__*/_jsx("path", {
      fill: "#E31D1C",
      fillRule: "evenodd",
      d: "M0 3v18h24V3H0Z",
      clipRule: "evenodd"
    }), /*#__PURE__*/_jsx("mask", {
      id: "b",
      width: "24",
      height: "18",
      x: "0",
      y: "3",
      maskUnits: "userSpaceOnUse",
      style: {
        maskType: 'luminance'
      },
      children: /*#__PURE__*/_jsx("path", {
        fill: "#fff",
        fillRule: "evenodd",
        d: "M0 3v18h24V3H0Z",
        clipRule: "evenodd"
      })
    }), /*#__PURE__*/_jsxs("g", {
      mask: "url(#b)",
      children: [/*#__PURE__*/_jsx("path", {
        fill: "#2E42A5",
        fillRule: "evenodd",
        d: "M0 3v9h24V3H0Z",
        clipRule: "evenodd"
      }), /*#__PURE__*/_jsx("path", {
        fill: "#212124",
        fillRule: "evenodd",
        d: "M3.599 11.29s.905.563 3.002.563c2.097 0 3.21-.563 3.21-.563s-1.644-.956-3.115-.956c-1.47 0-3.097.956-3.097.956Z",
        clipRule: "evenodd"
      }), /*#__PURE__*/_jsx("path", {
        fill: "#FFD83D",
        stroke: "#212124",
        strokeWidth: ".25",
        d: "m3.653 8.057-.108.063.036.062h6.407l.028-.088-.12-.037.12.037v-.001l.002-.004.004-.014a2.553 2.553 0 0 0 .06-.242c.034-.16.07-.38.08-.624.02-.48-.06-1.09-.51-1.48-.432-.375-1.037-.564-1.618-.662A9.392 9.392 0 0 0 6.49 4.96c-.785 0-1.503.092-2.672.754a1.195 1.195 0 0 0-.578.695 1.678 1.678 0 0 0-.028.797 3.02 3.02 0 0 0 .32.893l.009.015.002.004v.001l.109-.062Z"
      }), /*#__PURE__*/_jsx("path", {
        fill: "#FFD83D",
        stroke: "#212124",
        strokeWidth: ".25",
        d: "m3.002 8.345-.058-.11-.097.05.038.103.864 2.376.04.111.113-.034h.004l.012-.004.047-.013a12.247 12.247 0 0 1 .823-.192c.535-.106 1.246-.211 1.958-.211s1.41.105 1.93.21a11.376 11.376 0 0 1 .8.192l.045.014.01.003h.003l.001.001.113.035.041-.11.889-2.377.038-.103-.097-.051-.058.11.058-.11-.002-.001-.003-.002-.012-.006a3.475 3.475 0 0 0-.226-.098 6.276 6.276 0 0 0-.709-.226c-.629-.164-1.572-.326-2.836-.326-1.263 0-2.206.162-2.836.326a6.27 6.27 0 0 0-.708.226 3.473 3.473 0 0 0-.226.098l-.012.006-.004.002h-.001l.058.111Z"
      }), /*#__PURE__*/_jsxs("mask", {
        id: "c",
        width: "3",
        height: "4",
        x: "5.088",
        y: "2",
        fill: "#000",
        maskUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/_jsx("path", {
          fill: "#fff",
          d: "M5.088 2h3v4h-3z"
        }), /*#__PURE__*/_jsx("path", {
          fillRule: "evenodd",
          d: "M6.845 3h-.379l.05.692-.428-.058v.475l.434-.06-.056 1.09h.379l-.056-1.091.434.061v-.475l-.427.061L6.845 3Z",
          clipRule: "evenodd"
        })]
      }), /*#__PURE__*/_jsx("path", {
        fill: "#FFD83D",
        fillRule: "evenodd",
        d: "M6.845 3h-.379l.05.692-.428-.058v.475l.434-.06-.056 1.09h.379l-.056-1.091.434.061v-.475l-.427.061L6.845 3Z",
        clipRule: "evenodd"
      }), /*#__PURE__*/_jsx("path", {
        fill: "#212124",
        d: "M6.466 3v-.25h-.268l.019.268.25-.018Zm.379 0 .249.017.018-.267h-.267V3Zm-.33.692-.034.248.305.041-.022-.306-.249.017Zm-.427-.058.034-.248-.284-.038v.286h.25Zm0 .475h-.25v.287l.284-.039-.034-.248Zm.434-.06.25.013.015-.301-.3.041.035.248Zm-.056 1.09-.25-.012-.013.263h.263v-.25Zm.379 0v.25h.263l-.014-.262-.25.013Zm-.056-1.091.035-.248-.3-.042.015.303.25-.013Zm.434.061-.035.248.285.04V4.11h-.25Zm0-.475h.25v-.288l-.286.04.036.248Zm-.427.061-.249-.017-.021.309.306-.044-.036-.248Zm-.33-.445h.379v-.5h-.379v.5Zm.298.425-.048-.693-.499.036.049.692.498-.035Zm-.71.207.427.058.068-.496-.427-.058-.067.496Zm.284.227v-.475h-.5v.475h.5Zm.15-.307-.434.06.068.495.434-.06-.068-.495Zm.228 1.35.055-1.09-.499-.025-.055 1.09.5.025Zm.129-.262h-.379v.5h.379v-.5Zm-.306-.83.056 1.092.5-.025-.057-1.092-.5.026Zm.719-.198L6.824 3.8l-.07.495.434.062.07-.495Zm-.285-.228v.475h.5v-.475h-.5Zm-.141.309.426-.062-.07-.494-.427.06.071.496Zm-.237-.96-.048.695.499.034.048-.695-.499-.034Z",
        mask: "url(#c)"
      })]
    })]
  })]
}));
//# sourceMappingURL=Liechtenstein.js.map